import { render, staticRenderFns } from "./btGameDetail.vue?vue&type=template&id=054c08ed"
import script from "./btGameDetail.vue?vue&type=script&lang=js"
export * from "./btGameDetail.vue?vue&type=script&lang=js"
import style0 from "./btGameDetail.vue?vue&type=style&index=0&id=054c08ed&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports